const fromDictionary = <T extends object, U>(
  dict: T,
  key: string | number | symbol,
  defaultValue: U
) => dict[key as keyof T]
    ? dict[key as keyof T]
    : defaultValue;

export default fromDictionary;